:host {
  display: block;
}

.spw-breadcrumb {
  font-size: 16px;
  max-width: 100%;
  width: 100%;

  &__list {
    display: flex;
    list-style: none;
    padding: 0;
    margin: 0;
    width: 100%;
    max-width: 100%;
  }

  &--multiline {
    .spw-breadcrumb__list {
      @include breakpoint(lg) {
        display: block;
      }
    }
    ::slotted(spw-breadcrumb-item:last-child) {
      @include breakpoint(lg) {
        display: block;
        margin-top: 12px;
      }
    }
  }
}

::slotted(spw-breadcrumb-item) {
  margin-right: 16px;
  padding-left: 20px;
  position: relative;
  display: none;
  &:after {
    position: absolute;
    top: 50%;
    transform: translateY(-50%);
    left: 0;
    font-family: 'Font Awesome 6 Free';
    font-weight: 700;
    content: '\f060';
    font-size: 14px;
    @include breakpoint(lg) {
      right: 0;
      left: auto;
      transform: translateY(-50%);
      content: '\f054';
      font-size: 12px;
    }
  }
  @include breakpoint(lg) {
    display: inline-block;
    padding-left: 0;
    padding-right: 20px;
  }
}

::slotted(spw-breadcrumb-item:last-child) {
  flex: 1;
  overflow: hidden;
  display: none;
  margin-right: 0;
  -webkit-box-orient: vertical;
  text-overflow: ellipsis;
  -webkit-line-clamp: 1;
  line-clamp: 1;
  padding-right: 0;
  &:after {
    display: none;
  }
  @include breakpoint(lg) {
    display: -webkit-box;
  }
}

.spw-breadcrumb:not(.spw-breadcrumb--multiline):not(.spw-breadcrumb--one-line) ::slotted(spw-breadcrumb-item:nth-last-child(2)) {
  display: -webkit-box !important;
}

.spw-breadcrumb--one-line {
  ::slotted(spw-breadcrumb-item) {
    display: none;
    @include breakpoint(lg) {
      display: inline-block;
    }
  }
  ::slotted(spw-breadcrumb-item:last-child) {
    overflow: initial;
    display: -webkit-box !important;
    &:after {
      display: block;
      @include breakpoint(lg) {
        display: none;
      }
    }
    @include breakpoint(lg) {
      display: inline-block;
    }
  }
}

.spw-breadcrumb--multiline {
  ::slotted(spw-breadcrumb-item) {
    display: none;
    @include breakpoint(lg) {
      display: inline-block;
    }
  }
  ::slotted(spw-breadcrumb-item:nth-last-child(2)) {
    overflow: initial;
    display: -webkit-box !important;
    &:after {
      display: block;
    }
    @include breakpoint(lg) {
      display: inline-block !important;
    }
  }
}

::slotted(.hidden-item) {
  display: none;
}

::slotted(.collapsed-item) {
  font-size: 0;
  position: relative;
  &:before {
    font-family: 'Font Awesome 6 Free';
    font-weight: 700;
    content: '\f141';
    font-size: 16px;
    color: var(--spw-color-themes-grey-grey-500);
  }
}

.spw-breadcrumb--surface-light {
  ::slotted(spw-breadcrumb-item) {
    &:after {
      opacity: 1;
      color: var(--spw-ds-primary);
      @include breakpoint(lg) {
        color: var(--spw-color-themes-grey-grey-600);
      }
    }
  }
}

.spw-breadcrumb--surface-dark {
  color: var(--spw-ds-white) !important;
  ::slotted(spw-breadcrumb-item) {
    &:after {
      opacity: 0.7;
      color: var(--spw-ds-white);
    }
  }
  ::slotted(.collapsed-item) {
    &:before {
      opacity: 0.7;
      color: var(--spw-ds-white);
    }
  }
}
